export class ManualApproval{
    created:boolean = false;
    totalEdited:boolean = false;
    hoursEdited:boolean = false;
    byUpload:boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/models/ApprovalManual.model.ts